export default __webpack_public_path__ + "static/media/Db_8.1d7d2dbb.png";